<template>
  <div>
    <el-row>
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="20">
        <div class="title">
          <h1>文枢链——AI驱动的文创设计云平台</h1>
        </div>
        <div class="picture">
          <img src="../assets/project17_3.png.webp" />
        </div>
        <div class="paper_published">
          项目获2025年中国国际大学生创新大赛省赛金奖（赛道第一）（项目负责人）
        </div>
      </el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>

    <el-row :gutter="40" style="margin-top: 50px">
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="10">
        <div class="picture">
          <img src="../assets/project17_1.png.webp" />
        </div>
      </el-col>
      <el-col :span="10">
        <div class="abstract">
          为博物馆、文旅IP运营商和文创企业提供智能化、数据驱动的IP运营与商品化一站式解决方案。
        </div>
      </el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>

    <el-row :gutter="40" style="margin-top: 50px">
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="10">
        <div class="sub-title">三大智能引擎，高效创作IP</div>
        <div class="text">
          “文枢链”整合市场热点洞察、IP形象生成、IP活化三大引擎于一体。
          <br /><br />
          IP洞察引擎：智能市场趋势分析，识别潜力IP，提供IP运营策略。
          <br /><br />
          IP生成引擎：通过文化语义DNA提炼设计元素，快速生成IP形象。
          <br /><br />
          IP活化引擎：将文化知识图谱转化为文创产品以及多场景适配的动态叙事内容。
        </div>
      </el-col>
      <el-col :span="10">
        <div class="picture">
          <img src="../assets/project17_2.png.webp" />
        </div>
      </el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>

    <el-row :gutter="40" style="margin-top: 50px">
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="10">
        <div class="picture">
          <img src="../assets/project17_3.png.webp" />
        </div>
      </el-col>
      <el-col :span="10">
        <div class="text">
          文枢链构建了从“洞察—生成—活化”的闭环流程，显著提升文创IP设计与商品化落地的整体效率。
        </div>
      </el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>

    <el-row :gutter="40" style="margin-top: 50px">
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="10">
        <div class="picture">
          <img src="../assets/project17_4.png.webp" />
        </div>
      </el-col>
      <el-col :span="10">
        <div class="sub-title">链接产业生态，创造对话语境</div>
        <div class="text">
          “文枢链”不仅是一个工具平台，更是链接文化资源方、设计师、生产商与消费者的产业生态赋能系统。
        </div>
      </el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>

    <el-row :gutter="40" style="margin-top: 50px">
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="10">
        <div class="picture">
          <img src="../assets/project17_5.png.webp" />
        </div>
      </el-col>
      <el-col :span="10"><div class="grid-content"></div></el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "Project17Zh",
};
</script>

<style scoped>
.picture img {
  width: 100%;
}
.paper_published {
  margin-top: 24px;
  font-size: 15px;
  color: #333;
  font-weight: 400;
  text-align: justify;
  line-height: 1.9;
  border-bottom: 1px solid #333;
  padding-bottom: 6px;
}
.sub-title {
  margin-bottom: 20px;
  font-size: 18px;
  color: #333;
  font-weight: 400;
}
.text {
  font-size: 15px;
  color: #333;
  font-weight: 100;
  text-align: justify;
  line-height: 1.9;
}
.abstract {
  margin-top: 20px;
  font-size: 15px;
  color: #333;
  font-weight: 100;
  text-align: justify;
  line-height: 1.9;
}
.grid-content {
  min-height: 36px;
}
.title {
  margin-top: 100px;
  text-align: center;
}
.title h1 {
  font-size: 30px;
  font-weight: 100;
  letter-spacing: 3px;
  color: #333333;
}
</style>
